/**
 * Silent Logger utility that implements console API methods but doesn't output anything
 * This is used to silence console messages in production while maintaining the same API
 */
class Logger {
    /**
     * Initializes the logger and optionally replaces the global console object
     * @param {boolean} replaceGlobalConsole - Whether to replace the global console object
     */
    static init(replaceGlobalConsole = false) {
        // Store original console for potential future use
        const originalConsole = { ...console };
        
        // Create silent methods that do nothing
        const silentLog = () => {};
        const silentError = () => {};
        const silentWarn = () => {};
        const silentInfo = () => {};
        const silentDebug = () => {};
        
        // Create the logger object with silent methods
        const logger = {
            log: silentLog,
            error: silentError,
            warn: silentWarn,
            info: silentInfo,
            debug: silentDebug,
            // Preserve other console methods (table, group, etc.)
            ...console
        };
        
        // Replace global console if requested
        if (replaceGlobalConsole) {
            // Store original methods for potential restoration
            logger._original = originalConsole;
            
            // Replace console methods
            console.log = silentLog;
            console.error = silentError;
            console.warn = silentWarn;
            console.info = silentInfo;
            console.debug = silentDebug;
        }
        
        // Return the logger instance
        return logger;
    }
    
    /**
     * Restores the original console methods if they were replaced
     */
    static restore() {
        if (console._original) {
            console.log = console._original.log;
            console.error = console._original.error;
            console.warn = console._original.warn;
            console.info = console._original.info;
            console.debug = console._original.debug;
            delete console._original;
        }
    }
}

export default Logger; 